import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutRecoveryEntries extends Layout {
    labelTotalCount: Label;
    sourceEdirecoveryCount: DataSource;
}
